import React from "react";

const AnimatedLogo = ({ style }) => {
  return (
    <object type="image/svg+xml" data={`/AnimatedLogo.svg`} alt="loading" style={{ ...style }}>
      Loading...
    </object>
  );
};

export default AnimatedLogo;
